module.exports = __webpack_public_path__ + "static/media/icon-tablets-light.aea65e32.svg";